export default __webpack_public_path__ + "static/media/480_portfolio04-fr-mobile.08fabe74.png";